import Walkthrough from './Walkthrough';

export default Walkthrough;